import queryString from 'querystring';

export const generateQueryParamsFromObj = (obj: any) => {
  Object.keys(obj).forEach(key => {
    const item = obj[key];
    if (!item) {
      delete obj[key];
    }
    if (typeof item === 'object') {
      obj[key] = JSON.stringify(item);
    }
  });
  return queryString.stringify(obj);
};

export const getUrlItems = (link: string) => {
  const items = link ? link.split('_') : [];
  return {
    id: items[1],
    additionalId: items[2],
    name: items[0],
  };
};

// `_` separates the parts of a `name_id` segment and `/ ? #` would break the route
// (the apps run on a HashRouter), so none of them can survive inside the name part.
const sanitiseNamePart = (name?: string): string => (name ?? '').trim().replace(/[_/?#]+/g, '-');

/**
 * Builds a `name_id` route segment — the convention `getUrlItems` reads back and
 * `AppBreadcrumbs` takes its label from. Always use this instead of interpolating
 * `${name}_${id}` by hand: a name containing `_` would otherwise shift the id along
 * and the page would load nothing.
 */
export const buildNameIdUrlSegment = (name: string | undefined, id: string): string =>
  `${sanitiseNamePart(name)}_${id}`;

/**
 * Pulls the id out of a `name_id` segment. The id is the last part, so legacy links
 * whose name part still carries underscores resolve too, and a bare id with no name
 * (hand-typed or from an older redirect) is returned as-is instead of coming back
 * undefined and firing a request against `/sites/undefined`.
 */
export const getIdFromUrlSegment = (segment?: string): string => {
  const parts = segment ? segment.split('_').filter(part => part) : [];
  return parts.length ? parts[parts.length - 1] : '';
};

export const getAuthPage = (pathname: string, url: string): string => {
  const arr = pathname.split('/');
  arr.pop();
  return arr.join('/') + url;
};

// React 17 renders javascript: hrefs (it only warns), so strip script-executing
// URIs before they reach an anchor. http(s), mailto, tel, blob and relative links pass through.
const DANGEROUS_HREF = /^\s*(javascript|vbscript|data):/i;

export const safeHref = (url?: string | null): string | undefined => {
  if (!url) {
    return undefined;
  }
  return DANGEROUS_HREF.test(url) ? undefined : url;
};
